/**
 * Firm Registry — Single source of truth for all firm slug lists (frontend).
 *
 * Every frontend module that needs a list of firms or review slug mappings
 * should import from here instead of hardcoding its own list.
 *
 * To add a new firm:   add its slug to INTERNAL_FIRMS + REVIEW_SLUG_MAP.
 * To add an external:  add to EXTERNAL_FIRMS + REVIEW_SLUG_MAP.
 * To archive a firm:   remove from INTERNAL_FIRMS.
 */

/** Internal firms (in MongoDB, firm_type="internal") */
export const INTERNAL_FIRMS = [
  "bulenox",
  "e8-markets",
  "elite-trader-funding",
  "top-one-futures",
  "tradeday",
  "blusky",
  "blue-guardian",
  "aquafutures",
  "yrm-prop",
  "alpha-futures",
];

/** External firms (profile/review pages exist but no DB record) */
export const EXTERNAL_FIRMS = ["topstep", "apex"];

/** All firms */
export const ALL_FIRM_SLUGS = [...INTERNAL_FIRMS, ...EXTERNAL_FIRMS];

/**
 * Review URL slug → DB firm slug mapping.
 * The review URL uses "aqua-futures" but the DB slug is "aquafutures".
 * All other slugs are identical in URL and DB.
 */
export const REVIEW_SLUG_MAP = {
  topstep: "topstep",
  apex: "apex",
  bulenox: "bulenox",
  "e8-markets": "e8-markets",
  tradeday: "tradeday",
  "blue-guardian": "blue-guardian",
  "elite-trader-funding": "elite-trader-funding",
  blusky: "blusky",
  "alpha-futures": "alpha-futures",
  "aqua-futures": "aquafutures",
  "yrm-prop": "yrm-prop",
  "top-one-futures": "top-one-futures",
};

/** Review URL slugs (for routing, data lookup) */
export const REVIEW_URL_SLUGS = Object.keys(REVIEW_SLUG_MAP);

/** Reverse map: DB firm slug → review URL slug */
export const FIRM_SLUG_TO_REVIEW_SLUG = Object.fromEntries(
  Object.entries(REVIEW_SLUG_MAP).map(([urlSlug, dbSlug]) => [dbSlug, urlSlug])
);
